<template>
  <div>
    <el-button-group v-if="!disabled" style="padding-bottom:10px;">
      <el-button type="primary" size="small" @click="fromLoad('add')">{{$l('form_table_btn_label_add')||'新增客户选项'}}</el-button>
    </el-button-group>
    <el-table
      ref="table"
      :data="tableData"
      v-loading="loading"
      size="small"
      :height="height"
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="categoryName"
        :label="$l('form_table_label_category')||'分类名称'"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="priceRange"
        :label="$l('form_table_label_price_range')||'价格范围'"
      ></el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="spec"
          :label="$l('form_table_label_spec')||'产品规格'"
      ></el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="testingProtocol"
          :label="$l('form_table_label_testing_protocol')||'测试规则'"
      ></el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="moq"
          :label="$l('form_table_label_moq')||'最低起订量'"
      ></el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="styles"
          :label="$l('form_table_label_style')||'款式'"
      ></el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          :label="$l('form_table_label_modifyInfo')||'修改信息'"
          width="200"
      >
        <template slot-scope="scope">
          <div>修改人:{{scope.row.modifyByName}}</div>
          <div>修改时间:{{scope.row.modifyDate}}</div>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png"/>
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据!'}}</p>
        </div>
      </div>
      <el-table-column
          :label="$l('form_table_label_operation'||'操作')"
          width="100"
      >
        <template slot-scope="scope">
          <el-button
              v-if="!disabled"
              size="mini"
              style="padding:5px;"
              @click="fromLoad('edit', scope.row.custLabelCode)"
              icon="el-icon-edit-outline"
          />
          <el-button
              v-if="!disabled"
              size="mini"
              style="padding:5px;"
              icon="el-icon-delete"
              type="danger"
              @click="delRow(scope.row.custLabelCode)"
          />
        </template>
      </el-table-column>
    </el-table>
    <edit ref="labels" :params="params" @success="saveSuccess" />
  </div>
</template>

<script>
import Edit from "../edit";
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    params: {
      default: null,
      type: Object,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  components: {
    Edit
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 选中的数据
      multipleSelection: [],
    };
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = "") {
      this.$refs.labels.load(ref, val);
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.$emit("submit");
    },
    delRow(val) {
      this.del(val);
    },
    del(val) {
      this.$confirm(this.$l("tips_delete") || "是否删除？", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确认",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      }).then(() => {
          this.$api.customerLabelsDel({ custLabelCode: val }).then(() => {
              this.$message({
                showClose: true,
                message: this.$l("tips_delete_ok") || "删除成功！",
                type: "success",
              })
              this.$emit("submit")
            })
        })
        .catch(() => {})
    }
  }
}
</script>
